import { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom';

import { AppBar, Toolbar, IconButton, Typography, Tooltip } from '@mui/material';
import { ExitToApp, Menu } from '@mui/icons-material';
import SideMenu from './sideMenu';

import { useUserState } from 'contexts/user'
import { removeUserToken } from 'utils/storage';

import { config } from 'config';

interface ILayoutProps {
  children: any;
}

const Layout = ({ children }: ILayoutProps) => {

  useLocation();
  useHistory()
  const { isLogin, user } = useUserState();

  const [menuOpen, setMenuOpen] = useState(false)
  const path = (window.location.pathname || '').split('/')[1]

  useEffect(() => {
    setMenuOpen(window.innerWidth > 600 && !['home', 'auth'].includes(path))
  }, [path])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%'
    }}>
      {isLogin ? (
        <>
          <AppBar
            position="static"
            style={{
              width: menuOpen ? 'calc(100% - 220px)' : '100%',
              marginLeft: menuOpen ? '220px' : 0,
              transition: 'all 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms'
            }} >
            <Toolbar variant="dense" style={{ paddingRight: '10px', justifyContent: 'space-between' }}>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                {!menuOpen && !['home', 'auth'].includes(path) &&
                  <IconButton
                    edge="start"
                    style={{ marginRight: '15px' }}
                    color="inherit"
                    aria-label="menu"
                    onClick={() => setMenuOpen(true)}
                    size="large">
                    <Menu />
                  </IconButton>
                }
                <Typography
                  variant="h6"
                  color="inherit"
                  style={{
                    letterSpacing: '0.05em',
                    marginRight: '20px'
                  }} >
                  {(['bingo', 'solitaire', 'bubble'].includes(path) ? `⬥${config.game.toUpperCase()}⬥ ` : '') + `CashOut ${config.env.toUpperCase()}`}
                </Typography>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className='appbar-profile'>
                  <Typography variant='subtitle2' style={{ lineHeight: 1.3 }}>{user.name}</Typography>
                  <Typography variant='subtitle2' style={{ lineHeight: 1 }}>{user.email}</Typography>
                </div>
                <Tooltip title='Logout'>
                  <IconButton
                    color='inherit'
                    onClick={() => { removeUserToken(); window.location.replace('/') }}
                    size="large">
                    <ExitToApp />
                  </IconButton>
                </Tooltip>
              </div>
            </Toolbar>
          </AppBar>

          <section
            style={{
              height: '100%',
              overflow: 'hidden'
            }} >

            <div
              style={{
                flexShrink: 0,
                width: menuOpen ? '220px' : 0
              }}>
              <SideMenu
                open={menuOpen}
                callback={(open) => setMenuOpen(open)} />
            </div>

            <div
              style={{
                flexGrow: 1,
                boxSizing: 'border-box',
                overflow: 'hidden',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                marginLeft: menuOpen ? '220px' : 0,
                transition: 'margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms'
              }} >
              {children}
            </div>
          </section>
        </>
      ) : (
        <>
          <AppBar position="static" >
            <Toolbar variant="dense">
              <Typography
                variant="h6"
                color="inherit"
                style={{ letterSpacing: '0.05em' }}
              >
                CashOut {config.env.toUpperCase()}
              </Typography>
            </Toolbar>
          </AppBar>
          {children}
        </>
      )}
    </div>
  );
}

export default Layout;
